import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {PayeeCustomer} from "../../model/payee_customer";
import {Observable} from "rxjs/Observable";
import {LocalStripeService} from "./local.stripe.service";

@Injectable()
export class CustomerResolver implements Resolve<PayeeCustomer>{

  constructor (private stripeService:LocalStripeService){}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<PayeeCustomer> | Promise<PayeeCustomer> | PayeeCustomer {

    let customerid;


    customerid = route.params['cust'];

    const customer$ = this.stripeService.getStripeCustomerByKey(customerid)
      .first();


    return customer$;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/stripe/customer-resolver.ts